import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from "react-router-dom";
import { getUserList } from "../../../../services/UserService";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import ModifyUser from "./ModifyUser";
import DeleteUser from "./DeleteUser";
import ViewUser from "./ViewUser";
import { CustomSelect } from '../../../../components';


const lengths = Utils.tableShowLengths();

function SettingUsers() {

  const [loading, setLoading] = useState(false);

  const [roleList, setRoleList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [totalUser, setTotalUser] = useState(0);
  const [userList, setUserList] = useState([]);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [groupId, setGroupId] = useState(0);
  const [isCall, setIsCall] = useState(false);
  const [listProcess, setListProcess] = useState('loading...');

  const [isGroupTab, setIsGroupTab] = useState(true);

  const userModalRef = useRef(null);
  const userRoleAccessRef = useRef(null);

  const [users, setUsers] = useState({
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    role_id: '',
    role_name: '',
    group_name: '',
    group_ids: []
  });

  useEffect(function () {
    setUserList([]);
    setListProcess('loading...');
    let obj = {
      limit: limit,
      search: search,
      page: page,
      group_id: groupId
    };

    getUserList(obj)
      .then(response => {
        setRoleList(response.data.roles);
        setGroupList(response.data.groups);
        setTotalUser(parseInt(response.data.count));
        setUserList(response.data.data);
        if (response.data.data.length === 0) {
          setListProcess('No Users available.');
        }
      })
      .catch(err => {
        setListProcess('No Users available.');
      });
  }, [limit, page, search, groupId, isCall]);

  useEffect(function () {
    let loginData = Utils.loginUserData();
    if (Object.keys(loginData).length > 0) {
      if (loginData.role_id > 3) {
        setIsGroupTab(false);
      }
    }
  }, []);

  const handleEditUser = (e, data) => {
    setUsers(data);
    userModalRef?.current.click();
  };

  const handleDeleteUser = (e, data) => {
    setUsers(data);
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="active show" id="user" role="tabpanel" aria-labelledby="user-tab">
        <div className="breadcrumbs">
          <ul>
            <li>Settings /</li>
            <li>Users</li>
          </ul>
        </div>
        <div className="nav nav-tabs setting-tabs" id="navtab" role="tablist">
          <NavLink to={"/settings/users"} className="nav-link active setting-link" id="users" type="button"
            role="tab">Users</NavLink>
          {isGroupTab === true && (
            <NavLink to={"/settings/users/group"} className="nav-link setting-link" id="group-tab" type="button"
              role="tab">Group</NavLink>
          )}
        </div>
        <div id="navContent" className="setting-panel">
          <div id="users-detail" className="setting-tab-section active" role="tabpanel">

            {/* HEADER */}
            <div className="setting-header-user-tab">
              <div className="setting-search">
                <div className="setting-search-box" autoComplete="off"  >
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search users..."
                   
                  />
                  <span className="setting-search-icon">
                    <i className="bi bi-search" />
                  </span>
                </div>
              </div>
              <div className="setting-action-box">
                <button
                  className="setting-btn-create"
                  data-bs-toggle="offcanvas"
                  ref={userModalRef}
                  data-bs-target="#modifyUser"
                >
                  + Create User
                </button>

                <CustomSelect
                  name="groupId"
                  id="groupId"
                  value={groupId}
                  onChange={(e) => setGroupId(e.target.value)}
                  placeholder="All Group"
                  options={[
                    { value: 0, label: "All Group" },
                    ...groupList.map((item) => ({
                      value: item.id,
                      label: item.name,
                    })),
                  ]}
                  className="setting-custom-select"
                />
              </div>

            </div>

            {/* TABLE */}
            <div className="setting-table-wrapper">
              <table className="setting-table">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Group</th>
                    <th className="setting-action-col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {userList.map((item, index) => (
                    <tr key={index}>
                      <td>{item.created_at}</td>
                      <td>{item.first_name + " " + item.last_name}</td>
                      <td>{item.email}</td>
                      <td>{item.role_name}</td>
                      <td>{item.group_name}</td>
                      <td className="setting-actions-col">
                        <i
                          className="bi bi-eye setting-icon setting-view"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#viewUser"
                          onClick={(e) => handleDeleteUser(e, item)}
                        />
                        <i
                          className="bi bi-trash setting-icon setting-delete"
                          onClick={(e) => handleDeleteUser(e, item)}
                          data-bs-toggle="modal"
                          data-bs-target="#deleteUserModal"
                        />
                        <i
                          className="bi bi-pencil-fill setting-icon setting-edit"
                          onClick={(e) => handleEditUser(e, item)}
                        />
                      </td>
                    </tr>
                  ))}

                  {userList.length === 0 && (
                    <tr>
                      <td colSpan={6} className="setting-empty">
                        {listProcess}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* FOOTER */}
            {totalUser > 10 && (
              <div className="setting-footer">
                <div className="setting-footer-left">
                  <span>Show</span>
                  <select
                    className="setting-select-small"
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    {lengths.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="setting-footer-right">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalUser}
                    pageRangeDisplayed={5}
                    onChange={(e) => setPage(e)}
                  />
                </div>
              </div>
            )}

            {/* COMPONENTS */}
            <ModifyUser {...{ users, setUsers, roleList, setLoading, groupList, userRoleAccessRef, setIsCall, isCall }} />
            <DeleteUser {...{ users, setUsers, setLoading, setIsCall, isCall }} />
            <ViewUser {...{ users, setUsers }} />

          </div>
        </div>

      </div>

      <span data-bs-toggle="modal" ref={userRoleAccessRef} data-bs-target="#userRoleAccess" />
      <div className="modal fade" id="userRoleAccess" tabIndex="-1" aria-labelledby="userRoleAccessLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            {/* <div className="modal-body p-0">
                            <img src="/images/DocuTik-users-role-access.png" alt="..." className="w-100"/>
                        </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default SettingUsers;